import { Component, OnInit, ViewChild } from '@angular/core';
import { NavService } from '../../_services/_nav.service';
import { BusquedaFiltros } from '../../_models/busqueda-filtros';
import { Table } from 'primeng/table';
import { CalendarioPropiedades } from '../../_models/calendario-propiedades';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfiguracionUrlExternaService } from '../../_services/configuracion-url-externa.service';
import { ConfiguracionUrlExterna } from '../../_models/configuracion-url-externa';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Sistema } from '../../_models/sistema';
import { SistemaService } from '../../_services/sistema.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { forkJoin } from 'rxjs';
import { UtilitiesService } from '../../utils/utilities.service';

@Component( {
  selector: 'app-extensiones-telefonicas-editar',
  templateUrl: 'extensiones-telefonicas-editar.component.html'
} )

export class ExtensionesTelefonicasEditarComponent implements OnInit {

  @ViewChild('dt') tabla: Table;

  public loadingData:boolean = true;
  public errorConfiguracion:boolean = false;
  public formConfigUrl: FormGroup;
  public configuracionUrl:ConfiguracionUrlExterna;
  private listaConfiguracionesUrl: ConfiguracionUrlExterna[];
  public listaSistemas: SelectItem[] = [];
  public submitted:boolean = false;
  public saving:boolean = false;
  public editando:boolean = false;
  public tituloBoton:string;
  public linkConEspacios:boolean = false;

  get f() {
    return this.formConfigUrl.controls;
  }

  constructor(private navService:NavService,
              private fb:FormBuilder,
              private confUrlExternaService:ConfiguracionUrlExternaService,
              private router:Router,
              private activeRoute:ActivatedRoute,
              private sistemaService:SistemaService,
              private confirmService:ConfirmationService,
              private utilityService:UtilitiesService){
  }

  ngOnInit(): void {
    this.cargarDatosIniciales();
  }

  private cargarDatosIniciales(){
    this.loadingData = true;
    this.activeRoute.params.subscribe( ( params: Params ) => {
      if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {
        this.confUrlExternaService.obtenerPorId( params[ 'id' ] ).subscribe( configUrl => {
          this.editando = true;
          this.tituloBoton = 'BTN_ACTUALIZAR';
          this.configuracionUrl = configUrl;
          /*this.getCofiguracionesUrl();
          this.getSistemas();*/
          this.setFormData(configUrl);
          this.cargarListas();
          //this.loadingData = false;
        } );
      } else {
        /*this.getCofiguracionesUrl();
        this.getSistemas();*/
        this.tituloBoton = 'BTN_GUARDAR';
        this.setFormData(null);
        this.cargarListas();
        //this.loadingData = false;
      }
    } );
  }

  private setFormData(data?:ConfiguracionUrlExterna){
    this.formConfigUrl = this.fb.group( {
      idConfiguracionUrlExterna: [ data ? data.idConfiguracionUrlExterna : null ],
      codigo: [ data ? data.codigo : null, [Validators.required] ],
      nombre: [ data ? data.nombre : null, [Validators.required] ],
      link: [ data ? data.link : null, [Validators.required] ],
      descripcion: [ data ? data.descripcion : null, [Validators.required] ],
      idSistema: [ data ? data.idSistema : null, [Validators.required] ]
    } );
  }

  private cargarListas(){
    forkJoin(
      this.confUrlExternaService.listado(),
      this.sistemaService.getEnabled()).subscribe(([ lstConfiguraciones, lstSistemas ]) => {
        if ( lstConfiguraciones ){
          this.listaConfiguracionesUrl = lstConfiguraciones;
        }

        if ( lstSistemas ){
          lstSistemas.map( s => {
            this.listaSistemas.push( { label: s.nombreSistema, value: s.idSistema } );
          });
        }

        this.loadingData = false;
    })
  }

  public onSubmit(){
    if ( !this.linkConEspacios ){
      this.confirmService.confirm( {
        message: this.navService.buscarMensaje( 'EXTENSIONESTELEFONICAS.MSG_CONFIRMACION' ),
        header: this.navService.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.guardarExtensionTelefonica();
        },
        reject: () => {
        }
      } );
    }
  }

  private guardarExtensionTelefonica(){
    this.submitted = true;
    this.saving = true;

    if ( this.formConfigUrl.valid ){
      const formValue = this.formConfigUrl.value as ConfiguracionUrlExterna;
      const dataSave = {
        idConfiguracionUrlExterna: formValue.idConfiguracionUrlExterna,
        codigo: formValue.codigo,
        nombre: formValue.nombre,
        link: formValue.link.trim(),
        descripcion: formValue.descripcion === '' ? null : formValue.descripcion,
        idSistema: formValue.idSistema
      } as ConfiguracionUrlExterna;

      if ( this.validarExistenciaCodigoConfiguracion(dataSave.codigo) ){
        this.saving = false;
        this.navService.setMesage( 0,
          {
            severity: 'info',
            summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.navService.buscarMensaje( 'EXTENSIONESTELEFONICAS.MSG_CODIGOEXISTENTE' )
          } );
      } else{

        if ( this.editando ){
          //Actualizar
          dataSave.auditoriaFecha = this.configuracionUrl.auditoriaFecha;
          dataSave.indicadorHabilitado = true;
          this.confUrlExternaService.actualizar(dataSave).subscribe( response => {
              this.saving = false;
              this.navService.setMesage( 0,
                {
                  severity: 'success',
                  summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
                  detail: this.navService.buscarMensaje( 'EXTENSIONESTELEFONICAS.MSG_REGISTROACTUALIZADO' )
                } );
              this.router.navigate(['apl/extensiones-telefonicas']);
            },
            e => {
              console.log(e);
              this.saving = false;
            });
        } else{
          const regUpdate = this.listaConfiguracionesUrl.filter(x => x.link.toLowerCase() === dataSave.link.toLowerCase() && !x.indicadorHabilitado);

          if ( regUpdate.length > 0 ){
            //Actualizar el indicador habilitado
            const dataUpdate = {
              idConfiguracionUrlExterna: regUpdate[0].idConfiguracionUrlExterna,
              codigo: formValue.codigo,
              nombre: formValue.nombre,
              link: regUpdate[0].link.trim(),
              descripcion: formValue.descripcion === '' ? null : formValue.descripcion,
              idSistema: formValue.idSistema,
              indicadorHabilitado: true,
              auditoriaFecha: regUpdate[0].auditoriaFecha
            } as ConfiguracionUrlExterna;

            this.confUrlExternaService.actualizar(dataUpdate).subscribe( response => {
                this.saving = false;
                this.navService.setMesage( 0,
                  {
                    severity: 'success',
                    summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
                    detail: this.navService.buscarMensaje( 'EXTENSIONESTELEFONICAS.MSG_REGISTROGUARDADO' )
                  } );
                this.router.navigate(['apl/extensiones-telefonicas']);
              },
              e => {
                console.log(e);
                this.saving = false;
              });
          }else{
            //Guardar nuevo
            this.confUrlExternaService.crear(dataSave).subscribe( response => {
                this.saving = false;
                this.navService.setMesage( 0,
                  {
                    severity: 'success',
                    summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
                    detail: this.navService.buscarMensaje( 'EXTENSIONESTELEFONICAS.MSG_REGISTROGUARDADO' )
                  } );
                this.router.navigate(['apl/extensiones-telefonicas']);
              },
              e => {
                console.log(e);
                this.saving = false;
              });
          }
        }
      }
    }else{
      this.saving = false;
    }
  }

  private validarExistenciaCodigoConfiguracion(codigo:string){
    let coincidencias = [];

    if ( this.editando )
      coincidencias = this.listaConfiguracionesUrl.filter(x => x.codigo.toLowerCase() === codigo.toLowerCase()  && x.idConfiguracionUrlExterna !== this.configuracionUrl.idConfiguracionUrlExterna);
    else
      coincidencias = this.listaConfiguracionesUrl.filter(x => x.codigo.toLowerCase() === codigo.toLowerCase() && x.indicadorHabilitado);

    if ( coincidencias && coincidencias.length > 0 ){
      this.navService.setMesage( 0,
        {
          severity: 'info',
          summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
          detail: this.navService.buscarMensaje( 'EXTENSIONESTELEFONICAS.MSG_CODIGOEXISTENTE' )
        } );

      return true;
    }else{
      return false;
    }
  }

  public validarLink(link:string){
    if ( link ){
      link = link.trim();
      const regExpCoincidir = new RegExp('^(http:\\/\\/|https:\\/\\/)');
      const regExpTest = regExpCoincidir.test(link.toLowerCase());

      if ( !regExpTest ){
        this.navService.setMesage( 0,
          {
            severity: 'info',
            summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.navService.buscarMensaje( 'EXTENSIONESTELEFONICAS.MSG_LINKINICIOINCORRECTO' )
          } );

        this.f.link.setValue(null);
        this.f.link.updateValueAndValidity();

      } else if ( this.utilityService.validateNoSpaces(link) ){
        this.linkConEspacios = true;
        this.navService.setMesage( 0,
          {
            severity: 'info',
            summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.navService.buscarMensaje( 'EXTENSIONESTELEFONICAS.MSG_LINKCONESPACIOS' )
          } );

      }else{
        let coincidencias = [];
        this.linkConEspacios = false;

        if ( this.editando )
          coincidencias = this.listaConfiguracionesUrl.filter(x => x.link.toLowerCase() === link.toLowerCase() && x.idConfiguracionUrlExterna !== this.configuracionUrl.idConfiguracionUrlExterna);
        else
          coincidencias = this.listaConfiguracionesUrl.filter(x => x.link.toLowerCase() === link.toLowerCase() && x.indicadorHabilitado);

        if ( coincidencias && coincidencias.length > 0 ){
          this.navService.setMesage( 0,
            {
              severity: 'info',
              summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
              detail: this.navService.buscarMensaje( 'EXTENSIONESTELEFONICAS.MSG_LINKEXISTENTE' )
            } );

          this.f.link.setValue(null);
          this.f.link.updateValueAndValidity();
        }
      }
    } else {

      this.f.link.setValue(null);
      this.f.link.updateValueAndValidity();
    }

  }

  public regresarListado(formDirty:boolean){
    if ( formDirty ){
      this.confirmService.confirm( {
        message: this.navService.buscarMensaje( 'EXTENSIONESTELEFONICAS.MSG_CANCELARREGISTRO' ),
        header: this.navService.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.router.navigate(['apl/extensiones-telefonicas']);
        },
        reject: () => {
        }
      } );
    } else{
      this.router.navigate(['apl/extensiones-telefonicas']);
    }
  }
}
